import { createContext, useContext } from "react";

export const themes = {
  green: {
    name: "Green",
    baseColorCodeLight: "#16A34A",
    baseColorCodeDark: "#166534",
    base: "light",
    colors: {
      baseLightColor: "#ffffff",
      baseDarkColor: "#131920",
      overlay:
        "bg-[#f8f9fb] bg-opacity-50 dark:bg-[#131920] dark:bg-opacity-50", //graph overlay
      navBg: "bg-[#f8f9fb] dark:bg-[#131920]", // sidebar bg
      bgGradientGreen: "bg-gradient-to-r from-green-600 to-green-700", //bg-gradient-to-r from-green-700 to-emerald-800
      bgGradientBluePurple:
        "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 border-purple-600",
      bgGradientBluePurpleLight:
        "bg-gradient-to-r from-blue-50 to-purple-50 hover:from-blue-50 hover:to-purple-50 ",
      borderBluePurple: "border-purple-600",
      textBluePurple: " text-purple-600  hover:text-purple-700 ",
      bgGradientDark: "bg-gradient-to-br from-slate-900 to-slate-800",
      breadCrumpTextWithHover:
        "text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-400", //nav breadcrumb text color
      dispatchPrimaryBg: "bg-[#ffffff] dark:bg-[#131920]", //overall bg
      primaryBg: "bg-gray-50 dark:bg-[#131920]", //overall bg
      text: "#757575", //chart text
      darkText: "#E0E0E0", //dark theme chart text
      progressColorCode: "stroke-[#17A358] dark:stroke-[#258657]",
      blocksBg: "bg-white dark:bg-[#131920]", //sections bg
      statusDotBorder: "border-white dark:border-[#131920]", //sections bg
      navText: "text-gray-600 dark:text-gray-300", //nav and overall text text-[#8897A4]
      hoverText: "hover:text-[#17A358] dark:hover:text-[#258657]",
      hoverWithBgAndText:
        "hover:bg-[#E9F1ED] dark:hover:bg-[#162C26] hover:text-[#17A358] dark:hover:text-[#258657]",
      hoverBg: "hover:bg-[#E9F1ED] dark:hover:bg-[#162C26]",
      hoverActiveLightBg: "hover:bg-green-50 dark:hover:bg-[#162C26]",
      activebg: "bg-[#E9F1ED] dark:bg-[#162C26]",
      button:
        "bg-[#17A358] dark:bg-[#258657] text-white dark:text-gray-100 cursor-pointer hover:brightness-50",
      lightButton:
        "border border-[#17A358] dark:border-[#258657] text-[#17A358] dark:text-[#258657] cursor-pointer hover:bg-[#17A358]  dark:hover:border-[#258657] hover:text-white dark:hover:text-gray-300",
      activeLightBg: "bg-green-50 dark:bg-[#162C26]",
      darkerActiveBg: "bg-[#17A358] dark:bg-[#258657]",
      activeText: "text-[#17A358] dark:text-[#258657]",
      activeBorder: "border-[#17A358] dark:border-[#258657]",
      hoverBorder:
        " border-[#f3f5f7] dark:border-[#258657] hover:border-[#17A358] dark:hover:border-[#258657]",
      borderColor: "border-gray-200 dark:border-[#3f4954]", //ebf1f5
      divideColor: "divide-gray-200 dark:divide-[#3f4954]", //ebf1f5
      inputFocusAndHover:
        "focus:ring-green-50 focus:border-green-400  hover:border-green-400 dark:focus:ring-green-900/50 dark:focus:border-green-800  dark:hover:border-green-800",
      selectFocusAndHover:
        "focus:ring-green-50 focus:border-green-400  hover:border-green-400 dark:focus:ring-green-900/50 dark:focus:border-green-800  dark:hover:border-green-800",
      shadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,0.16)_0px_4px_20px]",
      dashBoardShadow:
        "shadow-md dark:shadow dark:shadow-gray-500 dark:hover:shadow-gray-700",
      shadowHover:
        "shadow-lg hover:shadow dark:shadow-gray-500 dark:hover:shadow-gray-700",
      shadowGlow: "shadow-green-100 dark:shadow-green-700",
      //sidebar
      bgNavHover: "hover:bg-[#E9F1ED] dark:hover:bg-[#162C26]", //lightgreen
      navTextHover:
        "group-hover:text-[#17A358] dark:group-hover:text-[#258657]", //darkgreen
      navIconHover:
        "group-hover:text-[#7DC693] dark:group-hover:text-[#115636]", //mediumgreen
      userProfile0:
        "text-blue-600 dark:text-blue-100  bg-blue-100 dark:bg-blue-800",
      userProfile1:
        "text-[#6dc295] dark:text-[#6dc295]  bg-[#ddfff3] dark:bg-[#1b3c48]",
      userProfile2:
        "text-[#f2af9c] dark:text-[#d99689] bg-[#fceee9] dark:bg-[#4b313b]",
      button: "bg-[#04a754] dark:bg-[#04a754] text-white dark:text-gray-200",
      dangerButton:
        "bg-red-500 dark:bg-[#cf6679] text-white dark:text-gray-200",
      dangerLightButton: "bg-red-50 border-red-50  text-red-500 ",
      //graph colors
      activeFill: "#17A358",
      totalFill: "#1565C0",
      newRideFill: "#00838F",
      ongoingFill: "#EF6C00",
      scheduleFill: "#00695C",
      endedFill: "#4b1c7d",
      cancelFill: "#FF6B6B",
      userDenyFill: "#FF9F43",
      expiredFill: "#4C6EF5",
      userActiveFill: "#43A047",
      inactiveUserFill: "#E53935",
      userArchiveFill: "#E11D48",
      userTodayFill: "#2563EB",
      userTriedFailedFill: "#D97706",

      //dotColors
      dotActiveFill: "bg-[#17A358]",
      dotTotalFill: "bg-[#1565C0]",
      dotNewRideFill: "bg-[#00838F]",
      dotOngoingFill: "bg-[#EF6C00]",
      dotScheduleFill: "bg-[#00695C]",
      dotEndedFill: "bg-[#4b1c7d]",
      dotCancelFill: "bg-[#FF6B6B]",
      dotUserDenyFill: "bg-[#FF9F43]",
      dotExpiredFill: "bg-[#4C6EF5]",
      //switch
      switchBgActive: "bg-green-500 dark:bg-green-700",
      switchBgInActive: "bg-gray-200 dark:bg-gray-700",
      //hint
      hintColor: "text-gray-400 dark:text-gray-400",
      //framerMotion
      framerProgressLineActive: "",
      framerProgressLine: "bg-gray-200 dark:bg-[#3f4954]",
      mediumIconColor: "text-[#17A358] dark:text-[#115636]",
      //tablePagination
      paginationButtonsHover: "hover:bg-gray-100 dark:hover:bg-gray-600 ",
      //calender
      calenderHighlight: "bg-green-600 dark:bg-green-600",
      //user-view
      userViewSectionBackground: "bg-white dark:bg-[#1f2833]",
      userViewBackground: "bg-slate-50 dark:bg-[#1f2833]",
      //transaction details
      OCBalBgBorder:
        "bg-[#f3ffeb] dark:bg-[#1F2A1C] border-[#f3ffeb] dark:border-[#1F2A1C]",
      transactionDetailsTextAndBorder: "text-[#5d869e] border-[#5d869e] ",
      transactionDetailsBg: "bg-[#036ba3] dark:bg-[#024061]",
      driverRegSetupServArea: "bg-slate-50 text-slate-600",
      driverRegSetupProfileReq: "bg-purple-50 text-purple-700",
      driverRegSetupProfileReqDot: "bg-purple-600",
      //refferral code for profile
      referralCodeProfile:
        "text-sm border border-green-600 text-green-600 bg-green-50 border-dashed w-fit py-1 px-2 rounded-md uppercase whitespace-nowrap font-bold mt-1",
      //ride details
      fareChip: "bg-[#607d8b] dark:bg-[#455b66]",
      //disptcher
      tollChip: "bg-yellow-100 text-yellow-800",
      airportChip: "bg-blue-100 text-blue-800",
      surgeChip: "bg-emerald-100 text-emerald-800",
      time: "bg-[#f3f5f7] dark:bg-[#1f2833]",
      categorySplitShadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,1.5)_1px_1px_10px]",
      categoryCard: "",
      categoryActiveCard: "",
      categoryAvailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      categoryUnavailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      assistBg: "lg:bg-blue-50 lg:dark:bg-slate-700",
      dispatchActivity:
        "bg-[#f2f2f2] dark:bg-gray-800 hover:bg-[#eeeeee] dark:hover:bg-gray-700",
      nonActiveCategoryBg: "bg-slate-50 dark:bg-slate-700",
      nonActiveCategoryBorder: " border-slate-200 dark:border-slate-500",
      nonActiveCategoryText: " text-slate-600 dark:text-slate-300 ",
      //booking activity
      bookingActivityTabsActive:
        "bg-gradient-to-r from-green-600 to-emerald-600 text-white shadow-sm transform scale-[1.02]",
      bookingActivityTabsHover:
        "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300",
      rideCardSkeletionMainBg:
        "bg-white dark:bg-gray-800  shadow-sm  border-gray-100 dark:border-gray-700",
      rideCardSkeletionContentBg: "bg-gray-200 dark:bg-gray-600",
      noBookingsIcon: "text-indigo-500 dark:text-indigo-400",
      noBookingsIconBg: "bg-indigo-50 dark:bg-indigo-900/20",
      bookingActivityPaginationCard:
        "bg-white dark:bg-gray-800 border-gray-100 dark:border-gray-700",
      bookingActivityPaginationButton:
        "bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200  border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600",
      bookingActivityPaginationActiveButton:
        "bg-gradient-to-r from-green-600 to-emerald-600 text-white",
      activityCardBorder: "border-gray-200 dark:border-gray-700 ",
      activityCardBg: "bg-white dark:bg-gray-800",
      activityCardDateBg: "bg-gray-100 dark:bg-gray-700",
      retryActionBg: "bg-blue-50  text-blue-600",
      retryActionIcon: "text-blue-500",
      assignActionBg: "bg-purple-50  text-purple-600",
      assignActionIcon: "text-purple-500",
      viewActionBg: "bg-gray-50  text-gray-600",
      viewActionIcon: "text-gray-500",
      //
      pickupIconColor: "border-black dark:border-white",
      DropIconColor: "border-black dark:border-white",
      pathIconColor: "border-black dark:border-white",
      //
      blueLinkText:
        "text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-blue-400",
      loginBanner:
        "bg-gradient-to-br from-teal-600 via-green-600 to-emerald-700",
      loginBannerMobile:
        "bg-gradient-to-br from-teal-100 via-green-100 to-emerald-100 dark:from-gray-800 dark:via-slate-800 dark:to-zinc-800 lg:from-white lg:via-white lg:to-white dark:lg:from-[#131920] dark:lg:via-[#131920] dark:lg:to-[#131920]   text-gray-600 dark:text-gray-300",
      pageToUp:
        "bg-green-100 dark:bg-green-800 hover:bg-green-500 hover:text-white",
      toast: "#17A358",
      defaultRole: "bg-[#17A358] dark:bg-[#258657]",
      //
      phoneInputBackgroundLight: "#ffffff",
      phoneInputBackgroundDark: "#131920",
      phoneInputTextLight: "#374151",
      phoneInputTextDark: "#E0E0E0",
      phoneInputBorderLight: "#E2E8F0",
      phoneInputBorderDark: "#3f4954",
      phoneInputFocusLight: "#3f4954",
      phoneInputFocusDark: "#3f4954",
      phoneInputBorderHoverLight: "#66BB6A",
      phoneInputBorderHoverDark: "#276749",
      phoneInputCountryHoverDark: "#162C26",
      phoneInputCountryHoverLight: "#E9F1ED",
    },
  },

  blue: {
    name: "Blue",
    baseColorCodeLight: "#2563EB",
    baseColorCodeDark: "#1E40AF",
    base: "light",
    colors: {
      baseLightColor: "#ffffff",
      baseDarkColor: "#0f172a",
      overlay:
        "bg-[#f5f7ff] bg-opacity-50 dark:bg-[#0f172a] dark:bg-opacity-50",
      navBg: "bg-[#f5f7ff] dark:bg-[#0f172a]",
      bgGradientGreen: "bg-gradient-to-r from-blue-600 to-blue-700",
      bgGradientBluePurple:
        "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 border-indigo-600",
      bgGradientBluePurpleLight:
        "bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-50 hover:to-indigo-50",
      borderBluePurple: "border-indigo-600",
      textBluePurple: " text-purple-600  hover:text-purple-700 ",
      bgGradientDark: "bg-gradient-to-br from-slate-900 to-slate-800",
      breadCrumpTextWithHover:
        "text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-400",
      dispatchPrimaryBg: "bg-[#ffffff] dark:bg-[#131920]",
      primaryBg: "bg-gray-50 dark:bg-[#131920]",
      text: "#64748B",
      darkText: "#E2E8F0",
      progressColorCode: "stroke-[#2563EB] dark:stroke-[#1E40AF]",
      blocksBg: "bg-white dark:bg-[#131920]",
      statusDotBorder: "border-white dark:border-[#131920]",
      navText: "text-gray-600 dark:text-gray-300",
      hoverText: "hover:text-[#2563EB] dark:hover:text-[#60A5FA]",
      hoverWithBgAndText:
        "hover:bg-[#EFF6FF] dark:hover:bg-[#1E3A8A] hover:text-[#2563EB] dark:hover:text-[#60A5FA]",
      hoverBg: "hover:bg-[#EFF6FF] dark:hover:bg-[#1E3A8A]",
      hoverActiveLightBg: "hover:bg-blue-50 dark:hover:bg-[#1E3A8A]",
      activebg: "bg-[#EFF6FF] dark:bg-[#1E3A8A]",
      button:
        "bg-[#2563EB] dark:bg-[#1E40AF] text-white dark:text-gray-100 cursor-pointer hover:brightness-30",
      lightButton:
        "border border-[#2563EB] dark:border-[#1E40AF] text-[#2563EB] dark:text-[#60A5FA] cursor-pointer hover:bg-[#2563EB] dark:hover:border-[#1E40AF] hover:text-white dark:hover:text-gray-300",
      activeLightBg: "bg-blue-50 dark:bg-[#1E3A8A]",
      darkerActiveBg: "bg-[#2563EB] dark:bg-[#1E40AF]",
      defaultRole: "bg-[#17A358] dark:bg-[#258657]",
      activeText: "text-[#2563EB] dark:text-[#60A5FA]",
      activeBorder: "border-[#2563EB] dark:border-[#1E40AF]",
      hoverBorder:
        "border-[#f3f5f7] dark:border-[#1E40AF] hover:border-[#2563EB] dark:hover:border-[#1E40AF]",
      borderColor: "border-gray-200 dark:border-slate-700",
      divideColor: "divide-gray-200 dark:divide-slate-700",
      inputFocusAndHover:
        "focus:ring-blue-50 focus:border-blue-400 hover:border-blue-400 dark:focus:ring-blue-900/50 dark:focus:border-blue-800 dark:hover:border-blue-800",
      selectFocusAndHover:
        "focus:ring-blue-50 focus:border-blue-400 hover:border-blue-400 dark:focus:ring-blue-900/50 dark:focus:border-blue-800 dark:hover:border-blue-800",
      shadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,0.16)_0px_4px_20px]",
      dashBoardShadow:
        "shadow-md dark:shadow dark:shadow-blue-900 dark:hover:shadow-blue-800",
      shadowHover:
        "shadow-lg hover:shadow dark:shadow-blue-900 dark:hover:shadow-blue-800",
      shadowGlow: "shadow-blue-100 dark:shadow-blue-700",
      bgNavHover: "hover:bg-[#EFF6FF] dark:hover:bg-[#1E3A8A]",
      navTextHover:
        "group-hover:text-[#2563EB] dark:group-hover:text-[#60A5FA]",
      navIconHover:
        "group-hover:text-[#60A5FA] dark:group-hover:text-[#1E40AF]",
      userProfile0:
        "text-blue-600 dark:text-blue-100 bg-blue-100 dark:bg-blue-800",
      userProfile1:
        "text-[#3b82f6] dark:text-[#60A5FA] bg-[#dbeafe] dark:bg-[#1e3a8a]",
      userProfile2:
        "text-[#f2af9c] dark:text-[#d99689] bg-[#fceee9] dark:bg-[#4b313b]",
      dangerButton:
        "bg-red-500 dark:bg-[#cf6679] text-white dark:text-gray-200",
      dangerLightButton: "bg-red-50 border-red-50 text-red-500",
      activeFill: "#2563EB",
      totalFill: "#1D4ED8",
      newRideFill: "#0284C7",
      ongoingFill: "#0369A1",
      scheduleFill: "#1E40AF",
      endedFill: "#312E81",
      cancelFill: "#EF4444",
      userDenyFill: "#FF9F43",
      expiredFill: "#4C6EF5",
      userActiveFill: "#3B82F6",
      inactiveUserFill: "#E53935",
      userArchiveFill: "#E11D48",
      userTodayFill: "#2563EB",
      userTriedFailedFill: "#D97706",
      dotActiveFill: "bg-[#2563EB]",
      dotTotalFill: "bg-[#1D4ED8]",
      dotNewRideFill: "bg-[#0284C7]",
      dotOngoingFill: "bg-[#0369A1]",
      dotScheduleFill: "bg-[#1E40AF]",
      dotEndedFill: "bg-[#312E81]",
      dotCancelFill: "bg-[#EF4444]",
      dotUserDenyFill: "bg-[#FF9F43]",
      dotExpiredFill: "bg-[#4C6EF5]",
      switchBgActive: "bg-blue-500 dark:bg-blue-700",
      switchBgInActive: "bg-gray-200 dark:bg-gray-700",
      hintColor: "text-gray-400 dark:text-gray-400",
      framerProgressLineActive: "",
      framerProgressLine: "bg-gray-200 dark:bg-slate-700",
      mediumIconColor: "text-[#2563EB] dark:text-[#1E40AF]",
      paginationButtonsHover: "hover:bg-gray-100 dark:hover:bg-gray-600",
      calenderHighlight: "bg-blue-600 dark:bg-blue-600",
      userViewSectionBackground: "bg-white dark:bg-[#1f2833]",
      userViewBackground: "bg-slate-50 dark:bg-[#1f2833]",
      OCBalBgBorder:
        "bg-[#eff6ff] dark:bg-[#1E293B] border-[#eff6ff] dark:border-[#1E293B]",
      transactionDetailsTextAndBorder: "text-[#5d869e] border-[#5d869e]",
      transactionDetailsBg: "bg-[#2563EB] dark:bg-[#1E40AF]",
      driverRegSetupServArea: "bg-slate-50 text-slate-600",
      driverRegSetupProfileReq: "bg-indigo-50 text-indigo-700",
      driverRegSetupProfileReqDot: "bg-indigo-600",
      referralCodeProfile:
        "text-sm border border-blue-600 text-blue-600 bg-blue-50 border-dashed w-fit py-1 px-2 rounded-md uppercase whitespace-nowrap font-bold mt-1",
      fareChip: "bg-[#607d8b] dark:bg-[#455b66]",
      tollChip: "bg-yellow-100 text-yellow-800",
      airportChip: "bg-blue-100 text-blue-800",
      surgeChip: "bg-sky-100 text-sky-800",
      time: "bg-[#f3f5f7] dark:bg-[#1e293b]",
      categorySplitShadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,1.5)_1px_1px_10px]",
      categoryCard: "",
      categoryActiveCard: "",
      categoryAvailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      categoryUnavailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      assistBg: "lg:bg-blue-50 lg:dark:bg-slate-700",
      dispatchActivity:
        "bg-[#f2f2f2] dark:bg-slate-800 hover:bg-[#eeeeee] dark:hover:bg-slate-700",
      nonActiveCategoryBg: "bg-slate-50 dark:bg-slate-700",
      nonActiveCategoryBorder: "border-slate-200 dark:border-slate-500",
      nonActiveCategoryText: "text-slate-600 dark:text-slate-300",
      bookingActivityTabsActive:
        "bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-sm transform scale-[1.02]",
      bookingActivityTabsHover:
        "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300",
      rideCardSkeletionMainBg:
        "bg-white dark:bg-slate-800 shadow-sm border-gray-100 dark:border-slate-700",
      rideCardSkeletionContentBg: "bg-gray-200 dark:bg-slate-600",
      noBookingsIcon: "text-blue-500 dark:text-blue-400",
      noBookingsIconBg: "bg-blue-50 dark:bg-blue-900/20",
      bookingActivityPaginationCard:
        "bg-white dark:bg-slate-800 border-gray-100 dark:border-slate-700",
      bookingActivityPaginationButton:
        "bg-white dark:bg-slate-700 text-gray-700 dark:text-gray-200 border-gray-200 dark:border-slate-600 hover:bg-gray-50 dark:hover:bg-slate-600",
      bookingActivityPaginationActiveButton:
        "bg-gradient-to-r from-blue-600 to-indigo-600 text-white",
      activityCardBorder: "border-gray-200 dark:border-slate-700",
      activityCardBg: "bg-white dark:bg-slate-800",
      activityCardDateBg: "bg-gray-100 dark:bg-slate-700",
      retryActionBg: "bg-blue-50 text-blue-600",
      retryActionIcon: "text-blue-500",
      assignActionBg: "bg-indigo-50 text-indigo-600",
      assignActionIcon: "text-indigo-500",
      viewActionBg: "bg-gray-50 text-gray-600",
      viewActionIcon: "text-gray-500",
      pickupIconColor: "border-black dark:border-white",
      DropIconColor: "border-black dark:border-white",
      pathIconColor: "border-black dark:border-white",
      blueLinkText:
        "text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-blue-400",
      loginBanner: "bg-gradient-to-br from-sky-600 via-indigo-600 to-blue-700",
      loginBannerMobile:
        "bg-gradient-to-br from-sky-100 via-blue-100 to-indigo-100 dark:from-gray-800 dark:via-slate-800 dark:to-zinc-800 lg:from-white lg:via-white lg:to-white dark:lg:from-[#131920] dark:lg:via-[#131920] dark:lg:to-[#131920]   text-gray-600 dark:text-gray-300",
      pageToUp:
        "bg-blue-100 dark:bg-blue-800 hover:bg-blue-500 hover:text-white",
      toast: "#2563EB",
      //
      phoneInputBackgroundLight: "#ffffff",
      phoneInputBackgroundDark: "#131920",
      phoneInputTextLight: "#374151",
      phoneInputTextDark: "#E0E0E0",
      phoneInputBorderLight: "#E2E8F0",
      phoneInputBorderDark: "#3f4954",
      phoneInputFocusLight: "#2563EB",
      phoneInputFocusDark: "#1E40AF",
      phoneInputBorderHoverLight: "#2563EB",
      phoneInputBorderHoverDark: "#1E40AF",
      phoneInputCountryHoverDark: "#1E3A8A",
      phoneInputCountryHoverLight: "#EFF6FF",
    },
  },

  red: {
    name: "Red",
    baseColorCodeLight: "#DC2626",
    baseColorCodeDark: "#991B1B",
    base: "light",
    colors: {
      baseLightColor: "#ffffff",
      baseDarkColor: "#1a0f0f",
      overlay:
        "bg-[#fff5f5] bg-opacity-50 dark:bg-[#1a0f0f] dark:bg-opacity-50",
      navBg: "bg-[#fff5f5] dark:bg-[#1a0f0f]",
      bgGradientGreen: "bg-gradient-to-r from-red-600 to-red-700",
      bgGradientBluePurple:
        "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 border-indigo-600",
      bgGradientBluePurpleLight:
        "bg-gradient-to-r from-blue-50 to-indigo-50 hover:from-blue-50 hover:to-indigo-50",
      borderBluePurple: "border-rose-600",
      textBluePurple: " text-purple-600  hover:text-purple-700 ",
      bgGradientDark: "bg-gradient-to-br from-red-950 to-red-900",
      breadCrumpTextWithHover:
        "text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-400",
      dispatchPrimaryBg: "bg-[#ffffff] dark:bg-[#131920]",
      primaryBg: "bg-gray-50 dark:bg-[#131920]",
      text: "#7F1D1D",
      darkText: "#FEE2E2",
      progressColorCode: "stroke-[#DC2626] dark:stroke-[#991B1B]",
      blocksBg: "bg-white dark:bg-[#131920]",
      statusDotBorder: "border-white dark:border-[#131920]",
      navText: "text-gray-600 dark:text-gray-300",
      hoverText: "hover:text-[#DC2626] dark:hover:text-[#F87171]",
      hoverWithBgAndText:
        "hover:bg-[#FEF2F2] dark:hover:bg-[#450A0A] hover:text-[#DC2626] dark:hover:text-[#F87171]",
      hoverBg: "hover:bg-[#FEF2F2] dark:hover:bg-[#450A0A]",
      hoverActiveLightBg: "hover:bg-red-50 dark:hover:bg-[#450A0A]",
      activebg: "bg-[#FEF2F2] dark:bg-[#450A0A]",
      button:
        "bg-[#DC2626] dark:bg-[#991B1B] text-white dark:text-gray-100 cursor-pointer hover:brightness-30",
      lightButton:
        "border border-[#DC2626] dark:border-[#991B1B] text-[#DC2626] dark:text-[#F87171] cursor-pointer hover:bg-[#DC2626] dark:hover:border-[#991B1B] hover:text-white dark:hover:text-gray-300",
      activeLightBg: "bg-red-50 dark:bg-[#450A0A]",
      darkerActiveBg: "bg-[#DC2626] dark:bg-[#991B1B]",
      defaultRole: "bg-[#17A358] dark:bg-[#258657]",
      activeText: "text-[#DC2626] dark:text-[#F87171]",
      activeBorder: "border-[#DC2626] dark:border-[#991B1B]",
      hoverBorder:
        "border-[#f3f5f7] dark:border-[#991B1B] hover:border-[#DC2626] dark:hover:border-[#991B1B]",
      borderColor: "border-gray-200 dark:border-slate-700",
      divideColor: "divide-gray-200 dark:divide-slate-700",
      inputFocusAndHover:
        "focus:ring-red-50 focus:border-red-400 hover:border-red-400 dark:focus:ring-red-900/50 dark:focus:border-red-800 dark:hover:border-red-800",
      selectFocusAndHover:
        "focus:ring-red-50 focus:border-red-400 hover:border-red-400 dark:focus:ring-red-900/50 dark:focus:border-red-800 dark:hover:border-red-800",
      shadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,0.16)_0px_4px_20px]",
      dashBoardShadow:
        "shadow-md dark:shadow dark:shadow-red-900 dark:hover:shadow-red-800",
      shadowHover:
        "shadow-lg hover:shadow dark:shadow-red-900 dark:hover:shadow-red-800",
      shadowGlow: "shadow-red-100 dark:shadow-red-700",
      bgNavHover: "hover:bg-[#FEF2F2] dark:hover:bg-[#450A0A]",
      navTextHover:
        "group-hover:text-[#DC2626] dark:group-hover:text-[#F87171]",
      navIconHover:
        "group-hover:text-[#F87171] dark:group-hover:text-[#991B1B]",
      userProfile0:
        "text-blue-600 dark:text-blue-100 bg-blue-100 dark:bg-blue-800",
      userProfile1:
        "text-[#ef4444] dark:text-[#F87171] bg-[#fee2e2] dark:bg-[#450a0a]",
      userProfile2:
        "text-[#f2af9c] dark:text-[#d99689] bg-[#fceee9] dark:bg-[#4b313b]",
      dangerButton:
        "bg-red-500 dark:bg-[#cf6679] text-white dark:text-gray-200",
      dangerLightButton: "bg-red-50 border-red-50 text-red-500",
      activeFill: "#DC2626",
      totalFill: "#B91C1C",
      newRideFill: "#EF4444",
      ongoingFill: "#F87171",
      scheduleFill: "#991B1B",
      endedFill: "#7F1D1D",
      cancelFill: "#450A0A",
      userDenyFill: "#FF9F43",
      expiredFill: "#4C6EF5",
      userActiveFill: "#EF4444",
      inactiveUserFill: "#7F1D1D",
      userArchiveFill: "#E11D48",
      userTodayFill: "#DC2626",
      userTriedFailedFill: "#D97706",
      dotActiveFill: "bg-[#DC2626]",
      dotTotalFill: "bg-[#B91C1C]",
      dotNewRideFill: "bg-[#EF4444]",
      dotOngoingFill: "bg-[#F87171]",
      dotScheduleFill: "bg-[#991B1B]",
      dotEndedFill: "bg-[#7F1D1D]",
      dotCancelFill: "bg-[#450A0A]",
      dotUserDenyFill: "bg-[#FF9F43]",
      dotExpiredFill: "bg-[#4C6EF5]",
      switchBgActive: "bg-red-500 dark:bg-red-700",
      switchBgInActive: "bg-gray-200 dark:bg-gray-700",
      hintColor: "text-gray-400 dark:text-gray-400",
      framerProgressLineActive: "",
      framerProgressLine: "bg-gray-200 dark:bg-red-900",
      mediumIconColor: "text-[#DC2626] dark:text-[#991B1B]",
      paginationButtonsHover: "hover:bg-gray-100 dark:hover:bg-gray-600",
      calenderHighlight: "bg-red-600 dark:bg-red-600",
      userViewSectionBackground: "bg-white dark:bg-[#1f2833]",
      userViewBackground: "bg-slate-50 dark:bg-[#1f2833]",
      OCBalBgBorder:
        "bg-[#fff5f5] dark:bg-[#2B1515] border-[#fff5f5] dark:border-[#2B1515]",
      transactionDetailsTextAndBorder: "text-[#5d869e] border-[#5d869e]",
      transactionDetailsBg: "bg-[#DC2626] dark:bg-[#991B1B]",
      driverRegSetupServArea: "bg-slate-50 text-slate-600",
      driverRegSetupProfileReq: "bg-rose-50 text-rose-700",
      driverRegSetupProfileReqDot: "bg-rose-600",
      referralCodeProfile:
        "text-sm border border-red-600 text-red-600 bg-red-50 border-dashed w-fit py-1 px-2 rounded-md uppercase whitespace-nowrap font-bold mt-1",
      fareChip: "bg-[#607d8b] dark:bg-[#455b66]",
      tollChip: "bg-yellow-100 text-yellow-800",
      airportChip: "bg-blue-100 text-blue-800",
      surgeChip: "bg-orange-100 text-orange-800",
      time: "bg-[#f3f5f7] dark:bg-[#2b1a1a]",
      categorySplitShadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,1.5)_1px_1px_10px]",
      categoryCard: "",
      categoryActiveCard: "",
      categoryAvailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      categoryUnavailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      assistBg: "lg:bg-red-50 lg:dark:bg-red-950",
      dispatchActivity:
        "bg-[#f2f2f2] dark:bg-red-950 hover:bg-[#eeeeee] dark:hover:bg-red-900",
      nonActiveCategoryBg: "bg-slate-50 dark:bg-red-950",
      nonActiveCategoryBorder: "border-slate-200 dark:border-red-900",
      nonActiveCategoryText: "text-slate-600 dark:text-slate-300",
      bookingActivityTabsActive:
        "bg-gradient-to-r from-red-600 to-rose-600 text-white shadow-sm transform scale-[1.02]",
      bookingActivityTabsHover:
        "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300",
      rideCardSkeletionMainBg:
        "bg-white dark:bg-red-950 shadow-sm border-gray-100 dark:border-red-900",
      rideCardSkeletionContentBg: "bg-gray-200 dark:bg-red-900",
      noBookingsIcon: "text-red-500 dark:text-red-400",
      noBookingsIconBg: "bg-red-50 dark:bg-red-900/20",
      bookingActivityPaginationCard:
        "bg-white dark:bg-red-950 border-gray-100 dark:border-red-900",
      bookingActivityPaginationButton:
        "bg-white dark:bg-red-900 text-gray-700 dark:text-gray-200 border-gray-200 dark:border-red-800 hover:bg-gray-50 dark:hover:bg-red-800",
      bookingActivityPaginationActiveButton:
        "bg-gradient-to-r from-red-600 to-rose-600 text-white",
      activityCardBorder: "border-gray-200 dark:border-red-900",
      activityCardBg: "bg-white dark:bg-red-950",
      activityCardDateBg: "bg-gray-100 dark:bg-red-900",
      retryActionBg: "bg-blue-50 text-blue-600",
      retryActionIcon: "text-blue-500",
      assignActionBg: "bg-rose-50 text-rose-600",
      assignActionIcon: "text-rose-500",
      viewActionBg: "bg-gray-50 text-gray-600",
      viewActionIcon: "text-gray-500",
      pickupIconColor: "border-black dark:border-white",
      DropIconColor: "border-black dark:border-white",
      pathIconColor: "border-black dark:border-white",
      blueLinkText:
        "text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-blue-400",
      loginBanner: "bg-gradient-to-br from-orange-600 via-rose-600 to-red-700",
      loginBannerMobile:
        "bg-gradient-to-br from-orange-100 via-rose-100 to-red-100 dark:from-gray-800 dark:via-slate-800 dark:to-zinc-800 lg:from-white lg:via-white lg:to-white dark:lg:from-[#131920] dark:lg:via-[#131920] dark:lg:to-[#131920]   text-gray-600 dark:text-gray-300",
      pageToUp:
        "bg-blue-100 dark:bg-blue-800 hover:bg-blue-500 hover:text-white",
      toast: "#DC2626",
      //
      phoneInputBackgroundLight: "#ffffff",
      phoneInputBackgroundDark: "#131920",
      phoneInputTextLight: "#374151",
      phoneInputTextDark: "#E0E0E0",
      phoneInputBorderLight: "#E2E8F0",
      phoneInputBorderDark: "#3f4954",
      phoneInputFocusLight: "#3f4954",
      phoneInputFocusDark: "#3f4954",
      phoneInputBorderHoverLight: "#DC2626",
      phoneInputBorderHoverDark: "#991B1B",
      phoneInputCountryHoverDark: "#450A0A",
      phoneInputCountryHoverLight: "#FEF2F2",
    },
  },

  orange: {
    name: "Orange",
    baseColorCodeLight: "#EA580C",
    baseColorCodeDark: "#C2410C",
    base: "light",
    colors: {
      baseLightColor: "#ffffff",
      baseDarkColor: "#1a0f0a",
      overlay:
        "bg-[#fff7ed] bg-opacity-50 dark:bg-[#1a0f0a] dark:bg-opacity-50",
      navBg: "bg-[#fff7ed] dark:bg-[#1a0f0a]",
      bgGradientGreen: "bg-gradient-to-r from-orange-600 to-orange-700",
      bgGradientBluePurple:
        "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 border-purple-600",
      bgGradientBluePurpleLight:
        "bg-gradient-to-r from-blue-50 to-purple-50 hover:from-blue-50 hover:to-purple-50",
      borderBluePurple: "border-orange-600",
      textBluePurple: " text-purple-600  hover:text-purple-700 ",
      bgGradientDark: "bg-gradient-to-br from-orange-950 to-orange-900",
      breadCrumpTextWithHover:
        "text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-400",
      dispatchPrimaryBg: "bg-[#ffffff] dark:bg-[#131920]",
      primaryBg: "bg-gray-50 dark:bg-[#131920]",
      text: "#9A3412",
      darkText: "#FFEDD5",
      progressColorCode: "stroke-[#EA580C] dark:stroke-[#C2410C]",
      blocksBg: "bg-white dark:bg-[#131920]",
      statusDotBorder: "border-white dark:border-[#131920]",
      navText: "text-gray-600 dark:text-gray-300",
      hoverText: "hover:text-[#EA580C] dark:hover:text-[#FB923C]",
      hoverWithBgAndText:
        "hover:bg-[#FFF7ED] dark:hover:bg-[#431407] hover:text-[#EA580C] dark:hover:text-[#FB923C]",
      hoverBg: "hover:bg-[#FFF7ED] dark:hover:bg-[#431407]",
      hoverActiveLightBg: "hover:bg-orange-50 dark:hover:bg-[#431407]",
      activebg: "bg-[#FFF7ED] dark:bg-[#431407]",
      button:
        "bg-[#EA580C] dark:bg-[#C2410C] text-white dark:text-gray-100 cursor-pointer hover:brightness-30",
      lightButton:
        "border border-[#EA580C] dark:border-[#C2410C] text-[#EA580C] dark:text-[#FB923C] cursor-pointer hover:bg-[#EA580C] dark:hover:border-[#C2410C] hover:text-white dark:hover:text-gray-300",
      activeLightBg: "bg-orange-50 dark:bg-[#431407]",
      darkerActiveBg: "bg-[#EA580C] dark:bg-[#C2410C]",
      defaultRole: "bg-[#17A358] dark:bg-[#258657]",
      activeText: "text-[#EA580C] dark:text-[#FB923C]",
      activeBorder: "border-[#EA580C] dark:border-[#C2410C]",
      hoverBorder:
        "border-[#f3f5f7] dark:border-[#C2410C] hover:border-[#EA580C] dark:hover:border-[#C2410C]",
      borderColor: "border-gray-200 dark:border-[#3f4954]",
      divideColor: "divide-gray-200 dark:divide-[#3f4954]",
      inputFocusAndHover:
        "focus:ring-orange-50 focus:border-orange-400 hover:border-orange-400 dark:focus:ring-orange-900/50 dark:focus:border-orange-800 dark:hover:border-orange-800",
      selectFocusAndHover:
        "focus:ring-orange-50 focus:border-orange-400 hover:border-orange-400 dark:focus:ring-orange-900/50 dark:focus:border-orange-800 dark:hover:border-orange-800",
      shadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,0.16)_0px_4px_20px]",
      dashBoardShadow:
        "shadow-md dark:shadow dark:shadow-orange-900 dark:hover:shadow-orange-800",
      shadowHover:
        "shadow-lg hover:shadow dark:shadow-orange-900 dark:hover:shadow-orange-800",
      shadowGlow: "shadow-orange-100 dark:shadow-orange-700",
      bgNavHover: "hover:bg-[#FFF7ED] dark:hover:bg-[#431407]",
      navTextHover:
        "group-hover:text-[#EA580C] dark:group-hover:text-[#FB923C]",
      navIconHover:
        "group-hover:text-[#FB923C] dark:group-hover:text-[#9A3412]",
      userProfile0:
        "text-blue-600 dark:text-blue-100 bg-blue-100 dark:bg-blue-800",
      userProfile1:
        "text-[#f97316] dark:text-[#FB923C] bg-[#ffedd5] dark:bg-[#431407]",
      userProfile2:
        "text-[#f2af9c] dark:text-[#d99689] bg-[#fceee9] dark:bg-[#4b313b]",
      dangerButton:
        "bg-red-500 dark:bg-[#cf6679] text-white dark:text-gray-200",
      dangerLightButton: "bg-red-50 border-red-50 text-red-500",
      activeFill: "#EA580C",
      totalFill: "#C2410C",
      newRideFill: "#F97316",
      ongoingFill: "#FB923C",
      scheduleFill: "#9A3412",
      endedFill: "#7C2D12",
      cancelFill: "#FF6B6B",
      userDenyFill: "#FF9F43",
      expiredFill: "#4C6EF5",
      userActiveFill: "#F97316",
      inactiveUserFill: "#E53935",
      userArchiveFill: "#E11D48",
      userTodayFill: "#EA580C",
      userTriedFailedFill: "#D97706",
      dotActiveFill: "bg-[#EA580C]",
      dotTotalFill: "bg-[#C2410C]",
      dotNewRideFill: "bg-[#F97316]",
      dotOngoingFill: "bg-[#FB923C]",
      dotScheduleFill: "bg-[#9A3412]",
      dotEndedFill: "bg-[#7C2D12]",
      dotCancelFill: "bg-[#FF6B6B]",
      dotUserDenyFill: "bg-[#FF9F43]",
      dotExpiredFill: "bg-[#4C6EF5]",
      switchBgActive: "bg-orange-500 dark:bg-orange-700",
      switchBgInActive: "bg-gray-200 dark:bg-gray-700",
      hintColor: "text-gray-400 dark:text-gray-400",
      framerProgressLineActive: "",
      framerProgressLine: "bg-gray-200 dark:bg-[#3f4954]",
      mediumIconColor: "text-[#EA580C] dark:text-[#9A3412]",
      paginationButtonsHover: "hover:bg-gray-100 dark:hover:bg-gray-600",
      calenderHighlight: "bg-orange-600 dark:bg-orange-600",
      userViewSectionBackground: "bg-white dark:bg-[#1f2833]",
      userViewBackground: "bg-slate-50 dark:bg-[#1f2833]",
      OCBalBgBorder:
        "bg-[#fff7ed] dark:bg-[#2B1A10] border-[#fff7ed] dark:border-[#2B1A10]",
      transactionDetailsTextAndBorder: "text-[#5d869e] border-[#5d869e]",
      transactionDetailsBg: "bg-[#EA580C] dark:bg-[#C2410C]",
      driverRegSetupServArea: "bg-slate-50 text-slate-600",
      driverRegSetupProfileReq: "bg-orange-50 text-orange-700",
      driverRegSetupProfileReqDot: "bg-orange-600",
      referralCodeProfile:
        "text-sm border border-orange-600 text-orange-600 bg-orange-50 border-dashed w-fit py-1 px-2 rounded-md uppercase whitespace-nowrap font-bold mt-1",
      fareChip: "bg-[#607d8b] dark:bg-[#455b66]",
      tollChip: "bg-yellow-100 text-yellow-800",
      airportChip: "bg-blue-100 text-blue-800",
      surgeChip: "bg-amber-100 text-amber-800",
      time: "bg-[#f3f5f7] dark:bg-[#1f2833]",
      categorySplitShadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,1.5)_1px_1px_10px]",
      categoryCard: "",
      categoryActiveCard: "",
      categoryAvailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      categoryUnavailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      assistBg: "lg:bg-orange-50 lg:dark:bg-slate-700",
      dispatchActivity:
        "bg-[#f2f2f2] dark:bg-gray-800 hover:bg-[#eeeeee] dark:hover:bg-gray-700",
      nonActiveCategoryBg: "bg-slate-50 dark:bg-slate-700",
      nonActiveCategoryBorder: "border-slate-200 dark:border-slate-500",
      nonActiveCategoryText: "text-slate-600 dark:text-slate-300",
      bookingActivityTabsActive:
        "bg-gradient-to-r from-orange-600 to-amber-600 text-white shadow-sm transform scale-[1.02]",
      bookingActivityTabsHover:
        "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300",
      rideCardSkeletionMainBg:
        "bg-white dark:bg-gray-800 shadow-sm border-gray-100 dark:border-gray-700",
      rideCardSkeletionContentBg: "bg-gray-200 dark:bg-gray-600",
      noBookingsIcon: "text-orange-500 dark:text-orange-400",
      noBookingsIconBg: "bg-orange-50 dark:bg-orange-900/20",
      bookingActivityPaginationCard:
        "bg-white dark:bg-gray-800 border-gray-100 dark:border-gray-700",
      bookingActivityPaginationButton:
        "bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600",
      bookingActivityPaginationActiveButton:
        "bg-gradient-to-r from-orange-600 to-amber-600 text-white",
      activityCardBorder: "border-gray-200 dark:border-gray-700",
      activityCardBg: "bg-white dark:bg-gray-800",
      activityCardDateBg: "bg-gray-100 dark:bg-gray-700",
      retryActionBg: "bg-blue-50 text-blue-600",
      retryActionIcon: "text-blue-500",
      assignActionBg: "bg-orange-50 text-orange-600",
      assignActionIcon: "text-orange-500",
      viewActionBg: "bg-gray-50 text-gray-600",
      viewActionIcon: "text-gray-500",
      pickupIconColor: "border-black dark:border-white",
      DropIconColor: "border-black dark:border-white",
      pathIconColor: "border-black dark:border-white",
      blueLinkText:
        "text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-blue-400",
      loginBanner:
        "bg-gradient-to-br from-amber-600 via-orange-600 to-orange-700",
      loginBannerMobile:
        "bg-gradient-to-br from-amber-100 via-orange-100 to-orange-100 dark:from-gray-800 dark:via-slate-800 dark:to-zinc-800 lg:from-white lg:via-white lg:to-white dark:lg:from-[#131920] dark:lg:via-[#131920] dark:lg:to-[#131920]   text-gray-600 dark:text-gray-300",
      pageToUp:
        "bg-orange-100 dark:bg-orange-800 hover:bg-orange-500 hover:text-white",
      toast: "#EA580C",
      phoneInputBackgroundLight: "#ffffff",
      phoneInputBackgroundDark: "#131920",
      phoneInputTextLight: "#374151",
      phoneInputTextDark: "#E0E0E0",
      phoneInputBorderLight: "#E2E8F0",
      phoneInputBorderDark: "#3f4954",
      phoneInputFocusLight: "#EA580C",
      phoneInputFocusDark: "#C2410C",
      phoneInputBorderHoverLight: "#EA580C",
      phoneInputBorderHoverDark: "#C2410C",
      phoneInputCountryHoverDark: "#431407",
      phoneInputCountryHoverLight: "#FFF7ED",
    },
  },

  violet: {
    name: "Violet",
    baseColorCodeLight: "#8F5BFF",
    baseColorCodeDark: "#6D28D9",
    base: "light",
    colors: {
      borderColorHexLight: "#e5e7eb",
      borderColorHexDark: "#3f4954",
      baseLightColor: "#ffffff",
      baseDarkColor: "#131920",
      overlay:
        "bg-[#f8f9fb] bg-opacity-50 dark:bg-[#131920] dark:bg-opacity-50",
      navBg: "bg-[#f8f9fb] dark:bg-[#131920]",
      bgGradientGreen: "bg-gradient-to-r from-violet-600 to-purple-700",
      bgGradientBluePurple:
        "bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 border-purple-600",
      bgGradientBluePurpleLight:
        "bg-gradient-to-r from-blue-50 to-purple-50 hover:from-blue-50 hover:to-purple-50 ",
      borderBluePurple: "border-purple-600",
      textBluePurple: " text-purple-600  hover:text-purple-700 ",
      bgGradientDark: "bg-gradient-to-br from-slate-900 to-slate-800",
      breadCrumpTextWithHover:
        "text-gray-600 hover:text-gray-900 dark:text-gray-300 dark:hover:text-gray-400",
      dispatchPrimaryBg: "bg-[#ffffff] dark:bg-[#131920]",
      primaryBg: "bg-gray-50 dark:bg-[#131920]",
      text: "#757575",
      darkText: "#E0E0E0",
      progressColorCode: "stroke-[#8F5BFF] dark:stroke-[#7C3AED]",
      blocksBg: "bg-white dark:bg-[#131920]",
      statusDotBorder: "border-white dark:border-[#131920]",
      navText: "text-gray-600 dark:text-gray-300",
      hoverText: "hover:text-[#8F5BFF] dark:hover:text-[#7C3AED]",
      hoverWithBgAndText:
        "hover:bg-[#F3EEFF] dark:hover:bg-[#241B38] hover:text-[#8F5BFF] dark:hover:text-[#7C3AED]",
      hoverBg: "hover:bg-[#F3EEFF] dark:hover:bg-[#241B38]",
      hoverActiveLightBg: "hover:bg-violet-50 dark:hover:bg-[#241B38]",
      activebg: "bg-[#F3EEFF] dark:bg-[#241B38]",
      button:
        "bg-[#8F5BFF] dark:bg-[#7C3AED] text-white dark:text-gray-100 cursor-pointer hover:brightness-40",
      lightButton:
        "border border-[#8F5BFF] dark:border-[#7C3AED] text-[#8F5BFF] dark:text-[#7C3AED] cursor-pointer hover:bg-[#8F5BFF]  dark:hover:border-[#7C3AED] hover:text-white dark:hover:text-gray-300",
      activeLightBg: "bg-violet-50 dark:bg-[#241B38]",
      darkerActiveBg: "bg-[#8F5BFF] dark:bg-[#7C3AED]",
      activeText: "text-[#8F5BFF] dark:text-[#7C3AED]",
      activeBorder: "border-[#8F5BFF] dark:border-[#7C3AED]",
      hoverBorder:
        " border-[#f3f5f7] dark:border-[#7C3AED] hover:border-[#8F5BFF] dark:hover:border-[#7C3AED]",
      borderColor: "border-gray-200 dark:border-[#3f4954]",
      divideColor: "divide-gray-200 dark:divide-[#3f4954]",
      inputFocusAndHover:
        "focus:ring-violet-50 focus:border-violet-400  hover:border-violet-400 dark:focus:ring-violet-900/50 dark:focus:border-violet-800  dark:hover:border-violet-800",
      selectFocusAndHover:
        "focus:ring-violet-50 focus:border-violet-400  hover:border-violet-400 dark:focus:ring-violet-900/50 dark:focus:border-violet-800  dark:hover:border-violet-800",
      shadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,0.16)_0px_4px_20px]",
      dashBoardShadow:
        "shadow-md dark:shadow dark:shadow-gray-500 dark:hover:shadow-gray-700",
      shadowHover:
        "shadow-lg hover:shadow dark:shadow-gray-500 dark:hover:shadow-gray-700",
      shadowGlow: "shadow-violet-100 dark:shadow-violet-700",
      bgNavHover: "hover:bg-[#F3EEFF] dark:hover:bg-[#241B38]",
      navTextHover:
        "group-hover:text-[#8F5BFF] dark:group-hover:text-[#7C3AED]",
      navIconHover:
        "group-hover:text-[#C4B0FF] dark:group-hover:text-[#4C1D95]",
      userProfile0:
        "text-blue-600 dark:text-blue-100  bg-blue-100 dark:bg-blue-800",
      userProfile1:
        "text-[#6dc295] dark:text-[#6dc295]  bg-[#ddfff3] dark:bg-[#1b3c48]",
      userProfile2:
        "text-[#f2af9c] dark:text-[#d99689] bg-[#fceee9] dark:bg-[#4b313b]",
      dangerButton:
        "bg-red-500 dark:bg-[#cf6679] text-white dark:text-gray-200",
      dangerLightButton: "bg-red-50 border-red-50  text-red-500 ",
      activeFill: "#8F5BFF",
      totalFill: "#1565C0",
      newRideFill: "#00838F",
      ongoingFill: "#EF6C00",
      scheduleFill: "#00695C",
      endedFill: "#4b1c7d",
      cancelFill: "#FF6B6B",
      userDenyFill: "#FF9F43",
      expiredFill: "#4C6EF5",
      userActiveFill: "#43A047",
      inactiveUserFill: "#E53935",
      userArchiveFill: "#E11D48",
      userTodayFill: "#2563EB",
      userTriedFailedFill: "#D97706",
      dotActiveFill: "bg-[#8F5BFF]",
      dotTotalFill: "bg-[#1565C0]",
      dotNewRideFill: "bg-[#00838F]",
      dotOngoingFill: "bg-[#EF6C00]",
      dotScheduleFill: "bg-[#00695C]",
      dotEndedFill: "bg-[#4b1c7d]",
      dotCancelFill: "bg-[#FF6B6B]",
      dotUserDenyFill: "bg-[#FF9F43]",
      dotExpiredFill: "bg-[#4C6EF5]",
      switchBgActive: "bg-violet-500 dark:bg-violet-700",
      switchBgInActive: "bg-gray-200 dark:bg-gray-700",
      hintColor: "text-gray-400 dark:text-gray-400",
      framerProgressLineActive: "",
      framerProgressLine: "bg-gray-200 dark:bg-[#3f4954]",
      mediumIconColor: "text-[#8F5BFF] dark:text-[#4C1D95]",
      paginationButtonsHover: "hover:bg-gray-100 dark:hover:bg-gray-600 ",
      calenderHighlight: "bg-violet-600 dark:bg-violet-600",
      userViewSectionBackground: "bg-white dark:bg-[#1f2833]",
      userViewBackground: "bg-slate-50 dark:bg-[#1f2833]",
      OCBalBgBorder:
        "bg-[#f6f2ff] dark:bg-[#211A2E] border-[#f6f2ff] dark:border-[#211A2E]",
      transactionDetailsTextAndBorder: "text-[#5d869e] border-[#5d869e] ",
      transactionDetailsBg: "bg-[#036ba3] dark:bg-[#024061]",
      driverRegSetupServArea: "bg-slate-50 text-slate-600",
      driverRegSetupProfileReq: "bg-purple-50 text-purple-700",
      driverRegSetupProfileReqDot: "bg-purple-600",
      referralCodeProfile:
        "text-sm border border-violet-600 text-violet-600 bg-violet-50 border-dashed w-fit py-1 px-2 rounded-md uppercase whitespace-nowrap font-bold mt-1",
      fareChip: "bg-[#607d8b] dark:bg-[#455b66]",
      tollChip: "bg-yellow-100 text-yellow-800",
      airportChip: "bg-blue-100 text-blue-800",
      surgeChip: "bg-emerald-100 text-emerald-800",
      time: "bg-[#f3f5f7] dark:bg-[#1f2833]",
      categorySplitShadow:
        "shadow-[rgba(0,0,0,0.09)_1px_4px_20px] dark:shadow-[rgba(255,255,255,1.5)_1px_1px_10px]",
      categoryCard: "",
      categoryActiveCard: "",
      categoryAvailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      categoryUnavailableChip:
        "bg-slate-50 text-slate-600 border border-slate-200",
      assistBg: "lg:bg-blue-50 lg:dark:bg-slate-700",
      dispatchActivity:
        "bg-[#f2f2f2] dark:bg-gray-800 hover:bg-[#eeeeee] dark:hover:bg-gray-700",
      nonActiveCategoryBg: "bg-slate-50 dark:bg-slate-700",
      nonActiveCategoryBorder: " border-slate-200 dark:border-slate-500",
      nonActiveCategoryText: " text-slate-600 dark:text-slate-300 ",
      bookingActivityTabsActive:
        "bg-gradient-to-r from-violet-600 to-purple-600 text-white shadow-sm transform scale-[1.02]",
      bookingActivityTabsHover:
        "hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-600 dark:text-gray-300",
      rideCardSkeletionMainBg:
        "bg-white dark:bg-gray-800  shadow-sm  border-gray-100 dark:border-gray-700",
      rideCardSkeletionContentBg: "bg-gray-200 dark:bg-gray-600",
      noBookingsIcon: "text-indigo-500 dark:text-indigo-400",
      noBookingsIconBg: "bg-indigo-50 dark:bg-indigo-900/20",
      bookingActivityPaginationCard:
        "bg-white dark:bg-gray-800 border-gray-100 dark:border-gray-700",
      bookingActivityPaginationButton:
        "bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200  border-gray-200 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-600",
      bookingActivityPaginationActiveButton:
        "bg-gradient-to-r from-violet-600 to-purple-600 text-white",
      activityCardBorder: "border-gray-200 dark:border-gray-700 ",
      activityCardBg: "bg-white dark:bg-gray-800",
      activityCardDateBg: "bg-gray-100 dark:bg-gray-700",
      retryActionBg: "bg-blue-50  text-blue-600",
      retryActionIcon: "text-blue-500",
      assignActionBg: "bg-purple-50  text-purple-600",
      assignActionIcon: "text-purple-500",
      viewActionBg: "bg-gray-50  text-gray-600",
      viewActionIcon: "text-gray-500",
      pickupIconColor: "border-black dark:border-white",
      DropIconColor: "border-black dark:border-white",
      pathIconColor: "border-black dark:border-white",
      blueLinkText:
        "text-blue-600 hover:text-blue-800 dark:text-blue-200 dark:hover:text-blue-400",
      loginBanner:
        "bg-gradient-to-br from-violet-600 via-purple-600 to-indigo-700",
      loginBannerMobile:
        "bg-gradient-to-br from-violet-100 via-purple-100 to-indigo-100 dark:from-gray-800 dark:via-slate-800 dark:to-zinc-800 lg:from-white lg:via-white lg:to-white dark:lg:from-[#131920] dark:lg:via-[#131920] dark:lg:to-[#131920]   text-gray-600 dark:text-gray-300",
      pageToUp:
        "bg-violet-100 dark:bg-violet-800 hover:bg-violet-500 hover:text-white",
      toast: "#8F5BFF",
      defaultRole: "bg-[#8F5BFF] dark:bg-[#7C3AED]",
      phoneInputBackgroundLight: "#ffffff",
      phoneInputBackgroundDark: "#131920",
      phoneInputTextLight: "#374151",
      phoneInputTextDark: "#E0E0E0",
      phoneInputBorderLight: "#E2E8F0",
      phoneInputBorderDark: "#3f4954",
      phoneInputFocusLight: "#3f4954",
      phoneInputFocusDark: "#3f4954",
      phoneInputBorderHoverLight: "#A78BFA",
      phoneInputBorderHoverDark: "#5B21B6",
      phoneInputCountryHoverDark: "#241B38",
      phoneInputCountryHoverLight: "#F3EEFF",
    },
  },
};

export const ThemeContext = createContext();

export const useThemes = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
